module.exports = __webpack_public_path__ + "img/41_41.9eaf37aa.png";